<script>
import {USpinnerFacebook} from 'uloc-vue'
export default {
  name: 'WindowLoading',
  props: ['errors', 'status'],
  data () {
    return {}
  },
  computed: {},
  mounted () {
  },
  destroyed () {
  },
  methods: {},
  components: {USpinnerFacebook}
}
</script>

<template>
  <div class="flex col-grow-1 content-center items-center h-full justify-center">
    <div class="flex col-grow-1 content-center items-center h-full justify-center" v-if="!errors">
      <slot>
        <div class="text-center">
          <u-spinner-facebook />
          <div>{{status}}</div>
        </div>
      </slot>
    </div>
    <span class="text-negative" v-else>{{errors}}</span>
  </div>
</template>
